<script>
import DashTip from "./DashTip";
import StatusMark from "./StatusMark";
import { fmtNum, fmtPct, semaphore, THRESHOLDS } from "@/data/dashboardModel";

// Barras tipo "bullet" por estándar: pista, relleno = % ponderado del estándar,
// marcas de umbral en 60 y 85 (Res. 0312) y "x/y ítems". Cada fila es un enlace
// enfocable a Estándares; hover y foco muestran el mismo tooltip.
export default {
  name: "BulletBar",
  components: { DashTip, StatusMark },
  props: {
    rows: { type: Array, default: () => [] }, // [{ number, name, cycleLabel, pct, approvedItems, requiredItems, approvedScore, requiredScore }]
    ready: { type: Boolean, default: false },
    to: { type: [String, Object], default: "/forms/estandares" },
  },
  data() {
    return { active: -1, tip: { x: 0, y: 0 } };
  },
  computed: {
    weakest() {
      let idx = -1;
      this.rows.forEach((r, i) => {
        if (r.pct !== null && (idx < 0 || r.pct < this.rows[idx].pct)) idx = i;
      });
      return idx;
    },
    marks() {
      return [THRESHOLDS.critical, THRESHOLDS.acceptable];
    },
  },
  methods: {
    fmtNum,
    fmtPct,
    semaphore,
    show(i, ev) {
      this.active = i;
      const host = this.$refs.host;
      const row = ev.currentTarget || ev.target;
      if (!host || !row) return;
      const hr = host.getBoundingClientRect();
      const rr = row.getBoundingClientRect();
      const track = row.querySelector(".dsh-bullet__track");
      const tr = track ? track.getBoundingClientRect() : rr;
      const r = this.rows[i];
      const frac = r.pct === null ? 0 : Math.min(100, r.pct) / 100;
      this.tip = { x: tr.left - hr.left + tr.width * Math.max(0.12, frac), y: rr.top - hr.top + 2 };
    },
    hide(i) {
      if (this.active === i) this.active = -1;
    },
  },
};
</script>

<template>
  <div ref="host" class="dsh-bullet">
    <div class="dsh-bullet__scale" aria-hidden="true">
      <span class="dsh-bullet__scale-label"></span>
      <span class="dsh-bullet__scale-track">
        <span v-for="m in marks" :key="m" :style="{ left: m + '%' }">{{ m }}</span>
      </span>
      <span class="dsh-bullet__scale-val"></span>
    </div>
    <ul class="dsh-bullet__list" aria-label="Cumplimiento por estándar, ordenado por número">
      <li v-for="(r, i) in rows" :key="r.number">
        <router-link
          :to="to"
          class="dsh-bullet__row"
          :class="{ 'is-active': active === i }"
          @mouseenter.native="show(i, $event)"
          @mouseleave.native="hide(i)"
          @focus.native="show(i, $event)"
          @blur.native="hide(i)"
        >
          <span class="dsh-bullet__label">
            <strong>{{ r.number }}. {{ r.name }}</strong>
            <small>{{ r.cycleLabel }} · {{ r.approvedItems }} de {{ r.requiredItems }} ítems<template v-if="i === weakest && rows.length > 1"> · el más flojo</template></small>
          </span>
          <span class="dsh-bullet__track" :class="{ 'is-na': r.pct === null }">
            <span
              v-if="r.pct !== null"
              class="dsh-bullet__fill"
              :style="{ width: (ready ? Math.min(100, r.pct) : 0) + '%', transitionDelay: i * 35 + 'ms' }"
            ></span>
            <span v-for="m in marks" :key="m" class="dsh-bullet__mark" :style="{ left: m + '%' }"></span>
          </span>
          <span class="dsh-bullet__val">
            <template v-if="r.pct !== null">{{ fmtPct(r.pct, 1) }}</template>
            <template v-else><span class="is-na">—</span></template>
          </span>
        </router-link>
      </li>
    </ul>
    <DashTip :show="active > -1" :x="tip.x" :y="tip.y">
      <template v-if="active > -1">
        <div class="dsh-tip__head">{{ rows[active].number }}. {{ rows[active].name }}</div>
        <div class="dsh-tip__value">{{ rows[active].pct === null ? "No aplica" : fmtPct(rows[active].pct) }}</div>
        <div class="dsh-tip__row">{{ fmtNum(rows[active].approvedScore) }} de {{ fmtNum(rows[active].requiredScore) }} puntos</div>
        <div class="dsh-tip__row">{{ rows[active].approvedItems }} de {{ rows[active].requiredItems }} ítems aprobados</div>
        <div v-if="rows[active].pct !== null" class="dsh-tip__status"><StatusMark :status="semaphore(rows[active].pct)" /></div>
      </template>
    </DashTip>
  </div>
</template>
